import { useContext } from "react";
import { CameraContext } from "../providers";

/**
 * Hook that returns the camera context value
 * 
 * @returns The camera context
 */
const useCameras = () => {
  const cameraContext = useContext(CameraContext);

  if (!cameraContext) {
    throw new Error("useCamera must be used within an CameraProvider");
  }
  return cameraContext;
};

export default useCameras;
